import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { type VisitWithCaseData } from "../types";
import { CaseHistoryDetailsEmptyState } from "./EmptyState";
import { CaseHistoryVisitCard } from "./VisitCard";

interface CaseHistoryDetailsVisitListProps {
  visits?: VisitWithCaseData[];
}

export function CaseHistoryDetailsVisitList(props: CaseHistoryDetailsVisitListProps) {
  const { visits } = props;

  if (!isDefined(visits) || isEmpty(visits)) {
    return <CaseHistoryDetailsEmptyState />;
  }

  return (
    <Stack width="100%" spacing={5}>
      {visits.map((visit) => (
        <CaseHistoryVisitCard key={visit.id} visit={visit} />
      ))}
    </Stack>
  );
}
